import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ImportedOrdersPageRoutingModule } from './imported-orders-routing.module';
import { ImportedOrdersPage as ImportedOrdersPage } from './imported-orders.page';
import { SharedModule } from '@shared/shared.module';
import { ImportedOrdersListDesktopComponent } from '@order/components/orders-list/imported-orders-view/desktop/imported-orders-list-desktop/imported-orders-list-desktop.component';
import { ImportedOrdersListMobileComponent } from '@order/components/orders-list/imported-orders-view/mobile/imported-orders-list-mobile/imported-orders-list-mobile.component';
import { ImportedOrdersListTabletComponent } from '@order/components/orders-list/imported-orders-view/tablet/imported-orders-list-tablet/imported-orders-list-tablet.component';
import { HeaderModule } from '../../../shared/components/header/header.module';
import { OrderCardActionsBarModule } from '@order/components/orders-list/order-card-actions-bar/order-card-actions-bar.module';

@NgModule({
  declarations: [
    ImportedOrdersPage,
    ImportedOrdersListDesktopComponent,
    ImportedOrdersListMobileComponent,
    ImportedOrdersListTabletComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImportedOrdersPageRoutingModule,
    SharedModule,
    HeaderModule,
    OrderCardActionsBarModule,
  ],
})
export class ImportedOrdersPageModule {}
